module.exports = __webpack_public_path__ + "static/media/invoicesActive.1cb4b018.svg";